export default __webpack_public_path__ + "static/media/Creditcard1.f6c7e416.svg";